export default (theme) => ({
    loadingContainer: {
        textAlign: "center"
    },
    //assetsDetails
    vinListItem: {
        padding: 0
    },
    messageContainer: {
        margin: theme.spacing(1)
    },
    downloadAssetContainer: {
        textAlign: "right"
    },
    spacer: {
        margin: `${theme.spacing(1)} 0`
    },
    // Audit details
    label: {
        margin: `${theme.spacing(1)} 0`
    }
});
